import { Navigate, useLocation } from 'react-router';
import { ReactNode } from 'react';

import { PATH_SETTINGS } from 'domains/userSettings/Routes';
import { isEmailConfirmationQuery } from 'domains/userSettings/utils/isEmailConfirmationQuery';

interface IEmailConfirmationGuardProps {
  children?: ReactNode;
}

export const EmailConfirmationGuard = ({
  children,
}: IEmailConfirmationGuardProps) => {
  const location = useLocation();

  const isEmailConfirmation = isEmailConfirmationQuery(location.search || '');

  if (isEmailConfirmation) {
    return <>{children}</>;
  }

  return <Navigate to={PATH_SETTINGS} replace />;
};
